// extracted by mini-css-extract-plugin
export default {"pointInput":"PointInput_pointInput__5vo8t"};